import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    margin: "0 11px 0 0",
    padding: 0,
    display: "flex",
    alignItems: "center",
    width: "100%",
    minWidth: spacing(38),
    maxWidth: spacing(70),
    position: "relative",
  },
  searchWrapper: {
    width: spacing(70),
  },
  searchFocused: {
    border: "inherit",
  },
  searchInput: {
    height: 22,
    padding: "8px 16px",
    border: `1px solid ${palette.grey[300]}`,
    borderTopLeftRadius: 2,
    borderBottomLeftRadius: 2,
    borderRight: 0,
    fontSize: 18,
    fontWeight: 600,
    "&:focus,&:active": {
      borderColor: palette.grey[300],
    },
    "&::-webkit-search-cancel-button": {
      display: "none",
    },
  },
  clearButton: {
    padding: 2,
    borderRadius: 0,
    minWidth: 30,
    position: "absolute",
    right: 38,
  },
  searchButtonWrapper: {
    margin: 0,
  },
  searchButton: {
    padding: "10px 13.5px",
    borderRadius: 0,
    borderTopRightRadius: 2,
    borderBottomRightRadius: 2,
    boxShadow: "none",
    minWidth: 30,
  },
  divider: {
    height: 20,
    margin: 0,
    padding: 0,
  },
}));

export default useStyles;
